module.exports = __webpack_public_path__ + "img/logo_nobackground.06ab4ab5.svg";